// frontend/src/components/common/OnboardingProgressBar.jsx
import React from 'react';
import { Check } from 'lucide-react';

const STEPS = [
  { label: 'Welcome', key: 'welcome' },
  { label: 'Choose Plan', key: 'choose_plan' },
  { label: 'Connect Bank', key: 'connect_bank' },
  { label: 'Review Bills', key: 'review_detected' },
];

export default function OnboardingProgressBar({ currentStep }) {
  const currentIndex = STEPS.findIndex(s => s.key === currentStep);

  return (
    <div className="w-full max-w-md mx-auto px-4 py-4">
      <div className="flex items-center justify-between">
        {STEPS.map((step, i) => {
          const isCompleted = i < currentIndex;
          const isCurrent = i === currentIndex;

          return (
            <React.Fragment key={step.key}>
              {/* Step circle */}
              <div className="flex flex-col items-center">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${
                  isCompleted
                    ? 'bg-emerald-600 text-white'
                    : isCurrent
                      ? 'bg-gray-900 text-white'
                      : 'bg-gray-200 text-gray-500'
                }`}>
                  {isCompleted ? <Check className="w-4 h-4" /> : i + 1}
                </div>
                <span className={`mt-1 text-xs ${
                  isCurrent ? 'text-gray-900 font-semibold' : 'text-gray-500'
                }`}>
                  {step.label}
                </span>
              </div>

              {/* Connector line (not after last step) */}
              {i < STEPS.length - 1 && (
                <div className={`flex-1 h-0.5 mx-2 ${
                  i < currentIndex ? 'bg-emerald-600' : 'bg-gray-200'
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
